/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RubricScoringCriterion } from './rubricScoringCriterion';
import type { RubricDimensionInputParams } from './rubricDimensionInputParams';

/**
 * Detailed rubric for a single dimension
 */
export interface RubricDimensionInput {
  /** Name of the dimension */
  name: string;
  /** Maximum points possible for this dimension */
  max_pts: number;
  /** Stored scoring criteria template (may contain placeholders in descriptors) */
  criteria: RubricScoringCriterion[];
  /** Parameters to format into criteria descriptors */
  params?: RubricDimensionInputParams;
}
